import Button from '@mui/material/Button'
import { IQDialog, Preloader } from '../../common'
import Typography from '@mui/material/Typography'
import { Stack } from '@mui/material'

interface IProps {
  isShow: boolean
  title: string
  saveAndStayButtonLabel?: string
  saveAndCloseButtonLabel?: string
  isSavingProcessing: boolean
  handleSaveAndStayButtonClick: () => void
  handleSaveAndCloseButtonClick: () => void
  handleCancelButtonClick: () => void
  dataTestId?: string
}

export const SaveConfirmationNew = ({
  isShow,
  title,
  saveAndStayButtonLabel,
  saveAndCloseButtonLabel,
  isSavingProcessing,
  handleSaveAndStayButtonClick,
  handleSaveAndCloseButtonClick,
  handleCancelButtonClick,
  dataTestId,
}: IProps) => {
  const renderCreateActions = () => (
    <Stack
      direction='row'
      spacing={1}
      justifyContent='space-between'
      sx={{ width: '100%' }}
    >
      <Button
        onClick={handleCancelButtonClick}
        data-testid={`${dataTestId}-cancel`}
        variant='outlined'
      >
        Cancel
      </Button>
      <Stack
        direction={'row'}
        spacing={1}
      >
        <Button
          disabled={isSavingProcessing}
          variant='contained'
          onClick={handleSaveAndStayButtonClick}
          data-testid={`${dataTestId}-save-stay`}
        >
          {saveAndStayButtonLabel || 'Save and Stay'}
        </Button>
        <Button
          disabled={isSavingProcessing}
          variant='contained'
          onClick={handleSaveAndCloseButtonClick}
          data-testid={`${dataTestId}-save-close`}
        >
          {saveAndCloseButtonLabel || 'Save and Close'}
        </Button>
      </Stack>
    </Stack>
  )

  return (
    <IQDialog
      isShow={isShow}
      title={''}
      content={
        isSavingProcessing ? (
          <Preloader
            size='sm'
            style={{ display: 'block', margin: '0 auto' }}
          />
        ) : (
          <Typography
            fontWeight='bold'
            fontSize={'20px'}
          >
            {title}
          </Typography>
        )
      }
      actions={renderCreateActions()}
      onClose={handleCancelButtonClick}
      testPrefix={`${dataTestId}-create`}
    />
  )
}
